import {RouteComponent} from "~/root/routeComponent";

export {ErrorBoundary} from "~/root/errorBoundary";
export {Layout} from "~/root/layout";
export {links} from "~/root/links";
export {loader} from "~/root/loader.server";
export {meta} from "~/root/meta";

export default RouteComponent;
